module.exports = __webpack_public_path__ + "img/argent.64e290f2.png";